<template>
  <CSidebar fixed :minimize="minimize" :show.sync="show">
    <div data-v-2534a5df="" class="c-sidebar-brand">
      <a rel="noopener" href="#">
        <!-- <span class="c-sidebar-brand-full">CCR <b>Manage</b>360</span>
        <span class="c-sidebar-brand-minimized"><b>M360</b></span> -->
        <div style="margin-left: 5px">
          <img
            class="c-sidebar-brand-minimized"
            src="https://manage360.constructedge.com/img/brand/ccr_logo.png"
            width="35"
          />
        </div>
        <div class="c-sidebar-brand-full">
          <img
            src="https://manage360.constructedge.com/img/brand/ccr_logo.png"
            width="35"
          /><span style="color: white">Manage360</span>
        </div>
      </a>
    </div>
    <div :key="refreshKey">
      <CRenderFunction
        flat
        :content-to-render="isNielsenCompany ? nav : ccrnav"
      />
    </div>
  </CSidebar>
</template>

<script>
import nav from "./_nav";
import ccrnav from "../../public/static-contents/_ccrnav";

export default {
  name: "TheSidebar",
  props: {
    minimize: Boolean,
  },
  data() {
    return {
      // user: this.$auth.user.UserDetails,
      // companyId: this.$auth.user.UserDetails.Company_RecID,
      nav,
      ccrnav,
      show: "responsive",
      clientProductIDs: [],
      user: this.$auth.user.UserDetails,
    };
  },
  computed: {
    isNielsenCompany() {
      return this.user.Company_RecID == 20822;
    },
    isCcrCompany() {
      return (
        this.user.Company_RecID == 2 && this.user.Contact_Company_RecID == 2
      );
    },
    refreshKey() {
      return this.$auth?.user?.UserDetails?.Company_RecID ?? 0;
    },
  },
  methods: {},
  watch: {},
  async created() {},
  mounted() {
    this.$root.$on("toggle-sidebar", () => {
      const sidebarOpened = this.show === true || this.show === "responsive";
      this.show = sidebarOpened ? false : "responsive";
    });
    this.$root.$on("toggle-sidebar-mobile", () => {
      const sidebarClosed = this.show === "responsive" || this.show === false;
      this.show = sidebarClosed ? true : "responsive";
    });
  },
};
</script>

<style>
.c-sidebar-brand a {
  color: #fff;
  font-size: 1.2rem;
}
.c-sidebar.c-sidebar-dark.c-sidebar-lg-show.c-sidebar-fixed.c-sidebar-minimized {
  z-index: 1;
}
/* .c-sidebar .c-sidebar-minimizer,
  .c-sidebar .c-sidebar-brand,
  .c-sidebar .c-sidebar-minimizer:hover {
    background-color: #1A1A1A;
  } */
/* border-right: 1px solid #4d4d4d; */
.c-sidebar .c-sidebar-nav-link.c-active,
.c-sidebar .c-sidebar-nav-link.c-active .c-sidebar-nav-icon {
  /* color: #fff; */
  /* background-color: #1A1A1A; */
  color: black;
  /*background-color: white;*/
  font-weight: bold;
  /* border-left: rgb(70, 165, 253) solid 3px; */
}
.c-sidebar .c-sidebar-nav-link.c-active:hover > .c-sidebar-nav-icon {
  color: white;
}
/* To be removed post approval

.c-sidebar .c-sidebar-nav-link.c-active .c-sidebar-nav-icon {
    color: black;
}

  .c-sidebar .c-sidebar-nav-link.c-active .c-sidebar-nav-icon:hover {
    color: white;
} */

.c-sidebar-nav {
  /* border-right: 1px solid lightgrey; */
  /* background-color: #1A1A1A; */
}

.c-sidebar.c-sidebar-minimized .c-sidebar-nav-item:hover > .c-sidebar-nav-link,
.c-sidebar.c-sidebar-unfoldable:not(:hover)
  .c-sidebar-nav-item:hover
  > .c-sidebar-nav-link,
.c-sidebar.c-sidebar-minimized
  .c-sidebar-nav-item:hover
  > .c-sidebar-nav-dropdown-toggle,
.c-sidebar.c-sidebar-unfoldable:not(:hover)
  .c-sidebar-nav-item:hover
  > .c-sidebar-nav-dropdown-toggle {
  background-color: #353535;
  color: white;
  /* font-weight: bold; */
}

.c-sidebar.c-sidebar-lg-show .c-sidebar-nav-item:hover > .c-sidebar-nav-link,
.c-sidebar.c-sidebar-unfoldable:not(:hover)
  .c-sidebar-nav-item:hover
  > .c-sidebar-nav-link,
.c-sidebar.c-sidebar-lg-show
  .c-sidebar-nav-item:hover
  > .c-sidebar-nav-dropdown-toggle,
.c-sidebar.c-sidebar-unfoldable:not(:hover)
  .c-sidebar-nav-item:hover
  > .c-sidebar-nav-dropdown-toggle {
  background-color: #353535;

  color: white;
  /* font-weight: bold; */
}
</style>
